import React from 'react';
import styled from 'styled-components';
import {useOutlet, useOutletSetter} from 'reconnect.js';
import {Button} from 'antd';
import {ShoppingCart} from '@styled-icons/material/ShoppingCart';
import NavLink from '../NavLink';
import constants from '../../constants';
import * as AppActions from '../../AppActions';
import {Cart} from '@styled-icons/bootstrap/Cart';
import {PersonCircle} from '@styled-icons/bootstrap/PersonCircle';
import {Menu as MenuIcon} from '@styled-icons/boxicons-regular/Menu';
import MobileNavDrawer from './MobileNavDrawer';
import * as NavUtil from '../../Utils/NavUtil';
import {showReservationModal} from '../ReservationModal';

export default function SiteNavBar(props) {
  const {location} = props;
  const [user] = useOutlet('user');
  const [cart] = useOutlet('cart');
  const [dimension] = useOutlet('dimension');
  const showLoginModal = useOutletSetter('login-modal');
  const [mobileNavVisible, setMobileNavVisible] = React.useState(false);
  const mobile = dimension.rwd !== 'desktop';
  const navItems = NavUtil.getNavItems(props);
  const beforehandRWD = navItems.length >= 5 && dimension.innerWidth <= 1150;

  React.useEffect(() => {
    setMobileNavVisible(false);
  }, [location?.pathname]);

  const navItemContent = (
    <>
      <div className="nav-items">
        {navItems.map((navItem, idx) => {
          const selected = NavUtil.isNavLinkSelected(navItem);

          if (navItem.entries) {
            return (
              <DropDownMenu>
                <button
                  className="dropdown-btn"
                  key={idx}
                  extraStyle={
                    selected
                      ? {
                          borderBottom: '6px solid var(--primaryColor)',
                          color: '#242424',
                          margin: 0,
                        }
                      : {margin: 0}
                  }>
                  {navItem.name}
                </button>

                <div className="dropdown-content">
                  {navItem.entries.map((item, i) => (
                    <NavLink
                      to={item.path}
                      className="nav-link"
                      key={i}
                      {...NavUtil.getNavLinkExtraProps(navItem)}>
                      {item.name}
                    </NavLink>
                  ))}
                </div>
              </DropDownMenu>
            );
          }

          return (
            <NavLink
              {...NavUtil.getNavLinkExtraProps(navItem)}
              to={navItem.path}
              key={idx}
              extraStyle={
                selected
                  ? {
                      borderBottom: '6px solid var(--primaryColor)',
                      color: '#242424',
                    }
                  : {}
              }>
              {navItem.name}
            </NavLink>
          );
        })}
      </div>

      <button className="nav-icon-btn-box">
        <a href="https://www.ystore.com.tw" target="_blank" rel="noreferrer">
          <ShoppingCart size={22} color={constants.EMPTY_CONFIG.THEME_COLOR} />
        </a>
      </button>

      <Button
        ghost
        type="primary"
        style={{marginLeft: 20}}
        onClick={() => showReservationModal({test: '123'})}>
        企業預約
      </Button>
    </>
  );

  const mobileNavItemContent = (
    <>
      <div className="nav-items">
        {navItems.map((navItem, idx) => {
          const selected = NavUtil.isNavLinkSelected(navItem);

          return (
            <>
              <NavLink
                {...NavUtil.getNavLinkExtraProps(navItem)}
                to={navItem.path}
                className="nav-link"
                key={`navitem-${idx}`}
                extraStyle={{
                  padding: '14px 20px',
                  fontSize: 16,
                  color: selected ? '#242424' : '#646464',
                }}>
                {navItem.name}
              </NavLink>
              {navItem.entries?.map((item, i) => (
                <NavLink
                  {...NavUtil.getNavLinkExtraProps(item)}
                  to={item.path}
                  key={`item-${i}`}
                  extraStyle={{
                    padding: '14px 20px',
                    fontSize: 16,
                    color: selected ? '#242424' : '#646464',
                  }}>
                  {item.name}
                </NavLink>
              ))}
            </>
          );
        })}
      </div>

      <div className="buttons">
        <button
          className="nav-icon-btn-box"
          style={{margin: '0px auto 10px auto'}}>
          <a href="https://www.ystore.com.tw" target="_blank" rel="noreferrer">
            <ShoppingCart
              size={22}
              color={constants.EMPTY_CONFIG.THEME_COLOR}
            />
          </a>
        </button>

        <Button
          ghost
          type="primary"
          onClick={() => showReservationModal({visible: true})}>
          企業預約
        </Button>
      </div>
    </>
  );

  return (
    <Wrapper id="rev-SiteNavBar">
      <div className="logo-box">
        <NavLink to="/" loading={800}>
          <img
            src="/images/site-logo.png"
            alt="Logo"
            style={{
              height: 40,
              objectFit: 'contain',
            }}
          />
        </NavLink>
      </div>

      {!mobile && !beforehandRWD ? (
        navItemContent
      ) : (
        <>
          <div style={{flex: 1}} />
          {user ? (
            <>
              <button
                className="nav-round-btn-box"
                style={{padding: 6}}
                onClick={async () => {
                  await AppActions.navigate('/checkout', {loading: 500});
                }}>
                <Cart size={20} />
                {cart?.items && <div>({cart.items.length})</div>}
              </button>
              <button
                className="nav-round-btn-box"
                style={{background: 'transparent', padding: 6}}
                onClick={async () => {
                  await AppActions.navigate('/profile', {loading: 500});
                }}>
                <PersonCircle size={20} color={constants.THEME_COLOR_SECOND} />
              </button>
            </>
          ) : (
            <button
              className="nav-round-btn-box"
              onClick={() => showLoginModal(true)}>
              <PersonCircle size={20} color={'white'} />
              <div>登入</div>
            </button>
          )}
          <div
            className="menu-btn-box"
            onClick={() => setMobileNavVisible(true)}>
            <MenuIcon size={20} />
          </div>
        </>
      )}

      <MobileNavDrawer
        visible={(mobile || beforehandRWD) && mobileNavVisible}
        setVisible={setMobileNavVisible}
        {...props}>
        {mobileNavItemContent}
      </MobileNavDrawer>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: fixed;
  background-color: white;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: var(--topNavBarHeight);
  padding: 16px 40px;
  display: flex;
  align-items: center;

  z-index: 101;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  transition: 200ms;

  &:hover {
    box-shadow: 0 5px 12px rgba(0, 0, 0, 0.16);
  }

  & > .logo-box {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  & > .nav-items {
    flex: 1;
    display: flex;
    align-items: center;
  }

  & > .menu-btn-box {
    padding: 8px;
    cursor: pointer;
  }

  & .nav-round-btn-box {
    display: flex;
    align-items: center;
    border-radius: 60px;
    padding: 6px 10px;
    background-color: ${constants.THEME_COLOR};
    color: white;
    outline: none;
    border: none;
    box-shadow: none;
    transition: all 200ms;
    cursor: pointer;

    & > * {
      margin: 0 3px;
    }
    &:hover {
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
    }
    &:active {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }
  }

  & .nav-icon-btn-box {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: none;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:hover {
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
    }
    &:active {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }
  }

  @media (max-width: 768px) {
    padding: 16px;

    & .nav-round-btn-box {
      justify-content: center;
    }
  }
`;

const DropDownMenu = styled.div`
  position: relative;
  display: inline-block;

  & > .dropdown-btn {
    border: none;
    background-color: #ffffff;
    padding: 0px 10px;
    cursor: pointer;
  }

  & > .dropdown-content {
    position: absolute;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 101;
    background-color: #ffffff;
    min-width: 100px;
    overflow: hidden;

    transition: all 150ms linear 100ms;
    height: 0px;
    padding: 0px;
    opacity: 0;

    & > a {
      display: block;
      line-height: 2.5;
    }
  }

  &:hover > .dropdown-btn {
    color: var(--secondColor);
  }

  &:hover > .dropdown-content {
    height: auto;
    padding: 15px 5px;
    opacity: 1;

    & > a:hover {
      color: var(--secondColor);
    }
  }
`;
